const SectionWithBg = ({ children }) => {
  return (
    <div
      className="relative before:content-[''] before:absolute  before:inset-0 before:-z-10 
   before:bg-urban_section_bg before:bg-no-repeat before:bg-top before:bg-cover before:opacity-40"
    >
      {children}
    </div>
  );
};

export default SectionWithBg;
